<!--

ServiceSystem Service Provider
Qwips 2021

-->
<template>
  <v-app>
    <router-view />
    <v-snackbar v-model="isSnackbarOpen" app color="warning" light>
      <v-icon class="mr-2">mdi-alert</v-icon>
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="closeSnackbar" fab small>
          <v-icon small>
            $close
          </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>
<script>
import AuthStoreMixin from "@/helpers/mixins/AuthStoreMixin";

export default {
  mixins: [AuthStoreMixin],
  computed: {
    isSnackbarOpen: {
      get() {
        return this.globalSnackbarOpen;
      },
      set(value) {
        this.setGlobalSnackbarOpen(value);
      },
    },
    snackbarMessage() {
      return this.globalSnackbarText;
    },
  },
  methods: {
    closeSnackbar() {
      this.setGlobalSnackbarOpen(false);
    },
  },
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Source+Code+Pro&display=swap");

:root,
.v-theme--light {
  --v-bottombar-base: #000;
  --v-primary-base: #427aaf;
  --v-accent-base: #ff8e00;
  --v-secondary-base: #ec6906;
  --v-tertiary-base: #4b39ee;
  --v-quaternary-base: #44af42;
  --v-quinary-base: #f1b202;
  --v-success-base: #4caf50;
  --v-info-base: #2e8ac0;
  --v-warning-base: #ff8e00;
  --v-error-base: #ff5252;
  --v-disabled-base: #ccc;
  --v-code-base: #f5f5f5;
}

html,
body,
.v-application {
  font-family: "Roboto", Arial, sans-serif;
  letter-spacing: 0;
}

#app {
  min-height: 100vh;
}

.v-card--variant-outlined {
  background-color: rgb(var(--v-theme-surface)) !important;
  border-color: #00000026 !important;
}

.source-code {
  [class*="text-"] {
    font-family: "Source Code Pro" !important;
    font-size: 0.7em;
  }

  [text-narrow] {
    line-height: 1.8 !important;
  }

  background-color: var(--v-code-base);
}

.overflow-overlay {
  overflow: overlay !important;
}

.overflow-x-overlay {
  overflow-x: overlay !important;
}

.overflow-y-overlay {
  overflow-x: overlay !important;
}

@-moz-document url-prefix() {

  //Firefox does not support overlay overflow, and interprets it as none instead of auto.
  .overflow-overlay {
    overflow: auto !important;
  }

  .overflow-x-overlay {
    overflow-x: auto !important;
  }

  .overflow-y-overlay {
    overflow-x: auto !important;
  }
}
</style>